import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'components/Modal'
import { DataTable } from 'components/DataTable'
import { CardItemList } from 'components/Card'
import { Checkbox } from 'components/forms'
import Button from 'components/Button'
import Divider from 'components/Divider'

const FilterCard = ({ data, methods, allItemsLabel, height, label, value = [], showModal, setShowModal, labelStyles, handleClick, handleAllActiveClick, listQuery, queryVariables, handleSave, columns, withSearch }) => {
	const [t] = useTranslation()
	const handleOpenModal = () => {
		setShowModal(true)
	}
	return(
		<>
			<CardItemList
				items={methods.handlerItems(allItemsLabel)}
				ItemComponent={({ item }) => item?.name || null}
				height={height || 200}
				label={`${label} ${value.length ? `(${value.length})` : ''}`}
				onAddItem={handleOpenModal}
				onRemoveItem={methods.handlerRemoveItem()}
				styleInverted
			/>
			{showModal &&
				<Modal label={label} width={400} unmount={() => setShowModal(null)} labelStyles={labelStyles}>
					<DataTable
						onRowClick={(obj, { original }) => handleClick(original)}
						columns={columns(t)}
						height={550}
						withSearch={withSearch}
						TheadComponent={({ className, style, children }) =>
							(
								<>
									<div className={`rt-thead ${className}`} style={style}>
										{children}
									</div>
									<div className={`rt-thead ${className}`} style={{ height: '36px' }}>
										<div className='rt-td' onClick={handleAllActiveClick}>
											<Checkbox noForm label={allItemsLabel} readOnly checked={methods.handlerCheckAll()}/>
										</div>
									</div>
								</>
							)
						}
						data={data}
						remoteOptions={listQuery && {
							query: listQuery,
							...{ ...queryVariables && queryVariables },
							withSort: true,
							fetchPolicy: 'cache-and-network'
						}}
					/>
					<Divider height={10}/>
					<Button text={t('common.buttons.apply')} onClick={handleSave} />
				</Modal>
			}
		</>
	)
}

export default FilterCard
